"use strict";
/**
 * Business-day helpers. The "business date" of a timestamp is the calendar
 * date (yyyy-mm-dd) in the given IANA timezone — e.g. a sale at 23:45 in
 * Los Angeles on March 9 belongs to business date 2026-03-09, regardless of
 * the UTC date.
 *
 * All POS-side and reconciliation-side code MUST use this helper instead of
 * `toISOString().slice(0,10)`, which would silently split days at UTC midnight.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBusinessDate = getBusinessDate;
exports.getTodayBusinessDate = getTodayBusinessDate;
/**
 * Returns the calendar date (yyyy-mm-dd) of the given timestamp in the given
 * IANA timezone (e.g. "America/Los_Angeles").
 *
 * Accepts ISO strings, epoch milliseconds, or Date objects.
 */
function getBusinessDate(timestamp, timezone) {
    const date = typeof timestamp === 'number'
        ? new Date(timestamp)
        : typeof timestamp === 'string'
            ? new Date(timestamp)
            : timestamp;
    if (Number.isNaN(date.getTime())) {
        throw new Error(`getBusinessDate: invalid timestamp ${String(timestamp)}`);
    }
    // Intl.DateTimeFormat with a timeZone option renders the date as it would
    // appear on a wall clock in that zone. 'en-CA' gives yyyy-mm-dd parts.
    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).formatToParts(date);
    const y = parts.find((p) => p.type === 'year')?.value;
    const m = parts.find((p) => p.type === 'month')?.value;
    const d = parts.find((p) => p.type === 'day')?.value;
    if (!y || !m || !d) {
        throw new Error(`getBusinessDate: could not format ${String(timestamp)} in timezone ${timezone}`);
    }
    return `${y}-${m}-${d}`;
}
/**
 * Returns "today" as a business date string (yyyy-mm-dd) in the given
 * IANA timezone.
 */
function getTodayBusinessDate(timezone) {
    return getBusinessDate(Date.now(), timezone);
}
//# sourceMappingURL=businessDate.js.map